module.exports = __webpack_public_path__ + "img/mizhi-back-one@3x.03dd22d5.png";